export default {
  title: 'Marketing Data',
  activityInfo: 'Activity Info',
  activityInfoPlaceholder: 'Enter activity name or ID',
  dateRange: 'Date Range',
  statTime: 'Stat Time',
  startDate: 'Start Date',
  endDate: 'End Date',
  // KPI Cards
  totalScanCount: 'Total Scans',
  cumulativeScanCount: 'Cumulative scan count',
  scanUserCount: 'Scan Users',
  activityUserCount: 'Activity Participants',
  winUserCount: 'Winners',
  yesterday: 'Yesterday:',
  // Trend Chart
  trendTitle: 'Scan Trend',
  periodWeek: 'This Week',
  periodMonth: 'This Month',
  scanCount: 'Scan Count',
  scanCountSeries: 'Scan Count',
  scanUserCountSeries: 'Scan Users',
  winCount: 'Winners',
  // Product Rank
  rankTitle: 'Scan Product Rank (TOP10)',
  rankNo: 'Rank',
  productName: 'Product',
  scanCountCol: 'Scan Count',
};
